/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RealEstateOwnerDto
 */
export interface RealEstateOwnerDto {
    /**
     * 
     * @type {string}
     * @memberof RealEstateOwnerDto
     */
    id: string;
    /**
     * Full name for natural persons, company name for legal entities
     * @type {string}
     * @memberof RealEstateOwnerDto
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof RealEstateOwnerDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof RealEstateOwnerDto
     */
    phone?: string;
    /**
     * Owner type
     * @type {string}
     * @memberof RealEstateOwnerDto
     */
    type: RealEstateOwnerDtoTypeEnum;
}


/**
 * @export
 */
export const RealEstateOwnerDtoTypeEnum = {
    Natural: 'natural',
    Legal: 'legal'
} as const;
export type RealEstateOwnerDtoTypeEnum = typeof RealEstateOwnerDtoTypeEnum[keyof typeof RealEstateOwnerDtoTypeEnum];


/**
 * Check if a given object implements the RealEstateOwnerDto interface.
 */
export function instanceOfRealEstateOwnerDto(value: object): value is RealEstateOwnerDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function RealEstateOwnerDtoFromJSON(json: any): RealEstateOwnerDto {
    return RealEstateOwnerDtoFromJSONTyped(json, false);
}

export function RealEstateOwnerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RealEstateOwnerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'type': json['type'],
    };
}

export function RealEstateOwnerDtoToJSON(json: any): RealEstateOwnerDto {
    return RealEstateOwnerDtoToJSONTyped(json, false);
}

export function RealEstateOwnerDtoToJSONTyped(value?: RealEstateOwnerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'email': value['email'],
        'phone': value['phone'],
        'type': value['type'],
    };
}

